module.exports = __webpack_public_path__ + "static/img/paystack-ii.eeedadb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paystack-ii.png
// module id = e/21
// module chunks = 1